import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, LinearProgress, Button, TextField } from "@material-ui/core";
import { Club } from "api/clubs";
import { postDashboardLogin } from "api/auth";
import i18n from "../i18n";

// prop types
interface EmbedDashboardDialogProps {
    club?: Club,
    show: boolean,
    onClose: () => void,
}

// embed dashboard dialog
const EmbedDashboardDialog = ({ club, show, onClose }: EmbedDashboardDialogProps) => {
    // ui state
    const [embedLink, setEmbedLink] = useState("");
    const [isLoading, setLoading] = useState(false);

    // create embed link
    const createLink = async () => {
        setLoading(true);
        const { token } = await postDashboardLogin(club!.clubKey!);
        const link = `${window.location.origin}/#/calendar?embed=${token}`;
        const code = `<iframe width="800" height="600" src="${link}"></iframe>`;
        setEmbedLink(code);
        setLoading(false);
    };
    useEffect(() => { if (club) createLink(); }, [club]); // eslint-disable-line

    // render
    return (
        <Dialog open={show} onClose={onClose}>
            <DialogTitle>{i18n.embedDashboard}</DialogTitle>
            <DialogContent dividers>
                <TextField
                    autoFocus
                    label={i18n.embedLink}
                    margin="normal"
                    multiline
                    onFocus={(e) => e.target.select()}
                    style={{ minWidth: "480px" }}
                    value={embedLink}
                />
            </DialogContent>
            {isLoading && <LinearProgress />}
            <DialogActions>
                <Button color="primary" onClick={onClose}>
                    {i18n.ok}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default EmbedDashboardDialog;
